// Application types

const PUBLICPAYMENT = {
  LOADING_PUBLIC_PAYMENT: "LOADING_PUBLIC_PAYMENT",
  SINGLE_PUBLIC_PAYMENT: "SINGLE_PUBLIC_PAYMENT",
};

export default PUBLICPAYMENT;
